import type { Step } from 'react-joyride';

export const financialTourSteps: Step[] = [
  {
    target: '#myFinancialTables',
    content: 'Aqui você encontra seu extrato com os lançamentos disponíveis, futuros e bloqueados',
  },
  {
    target: '#myTransferButton',
    content: 'Clicando aqui você consegue transferir valores disponíveis e antecipar valores na transferência',
  },
];
